import { RequestStatus } from 'store/utils';

import {
    deleteRecordingFailure,
    deleteSeriesRecordingFailure,
    getRecordingsCacheSuceess,
    setDeleteActionPinValidationTime,
} from './actions';
import {
    CANCEL_RECORDING,
    CANCEL_RECORDING_FAILURE,
    CANCEL_RECORDING_SUCCESS,
    CANCEL_SERIES_RECORDING,
    CANCEL_SERIES_RECORDING_FAILURE,
    CANCEL_SERIES_RECORDING_SUCCESS,
    DELETE_RECORDING,
    DELETE_RECORDING_FAILURE,
    DELETE_RECORDING_SUCCESS,
    DELETE_SERIES_RECORDING,
    DELETE_SERIES_RECORDING_FAILURE,
    DELETE_SERIES_RECORDING_SUCCESS,
    GET_RECORDINGS_CACHE_SUCCESS,
    PROTECT_RECORDING,
    PROTECT_RECORDING_FAILURE,
    PROTECT_RECORDING_SUCCESS,
    SCHEDULE_RECORDING,
    SCHEDULE_RECORDING_FAILURE,
    SCHEDULE_RECORDING_SUCCESS,
    SCHEDULE_SERIES_RECORDING,
    SCHEDULE_SERIES_RECORDING_FAILURE,
    SCHEDULE_SERIES_RECORDING_SUCCESS,
    SET_DELETE_ACTION_PIN_VALIDATION_TIME,
    UNPROTECT_RECORDING,
    UNPROTECT_RECORDING_FAILURE,
    UNPROTECT_RECORDING_SUCCESS,
} from './constants';
import { NPVRAction, RecordingsState } from './reducer.types';

const initialState: RecordingsState = {
    deleteRequest: {
        status: RequestStatus.IDLE,
        errors: null,
    },
    deleteSeriesRequest: {
        status: RequestStatus.IDLE,
        errors: null,
    },
    nPVRActions: [],

    cache: {
        timestamp: undefined,
        recordings: [],
        series: [],
    },

    deleteActionPinValidationTime: {},
};

const handlers = {
    [SCHEDULE_RECORDING](
        state: RecordingsState = initialState,
    ): RecordingsState {
        return {
            ...state,
            nPVRActions: [...state.nPVRActions, NPVRAction.SCHEDULE],
        };
    },
    [SCHEDULE_RECORDING_SUCCESS](
        state: RecordingsState = initialState,
    ): RecordingsState {
        return {
            ...state,
            nPVRActions: state.nPVRActions.filter(
                (action) => action !== NPVRAction.SCHEDULE,
            ),
        };
    },
    [SCHEDULE_RECORDING_FAILURE](
        state: RecordingsState = initialState,
    ): RecordingsState {
        return {
            ...state,
            nPVRActions: state.nPVRActions.filter(
                (action) => action !== NPVRAction.SCHEDULE,
            ),
        };
    },

    // SCHEDULE SERIES RECORDING
    [SCHEDULE_SERIES_RECORDING](
        state: RecordingsState = initialState,
    ): RecordingsState {
        return {
            ...state,
            nPVRActions: [...state.nPVRActions, NPVRAction.SCHEDULE_SERIES],
        };
    },
    [SCHEDULE_SERIES_RECORDING_SUCCESS](
        state: RecordingsState = initialState,
    ): RecordingsState {
        return {
            ...state,
            nPVRActions: state.nPVRActions.filter(
                (action) => action !== NPVRAction.SCHEDULE_SERIES,
            ),
        };
    },
    [SCHEDULE_SERIES_RECORDING_FAILURE](
        state: RecordingsState = initialState,
    ): RecordingsState {
        return {
            ...state,
            nPVRActions: state.nPVRActions.filter(
                (action) => action !== NPVRAction.SCHEDULE_SERIES,
            ),
        };
    },

    // PROTECT RECORDING
    [PROTECT_RECORDING](
        state: RecordingsState = initialState,
    ): RecordingsState {
        return {
            ...state,
            nPVRActions: [...state.nPVRActions, NPVRAction.PROTECT],
        };
    },
    [PROTECT_RECORDING_SUCCESS](
        state: RecordingsState = initialState,
    ): RecordingsState {
        return {
            ...state,
            nPVRActions: state.nPVRActions.filter(
                (action) => action !== NPVRAction.PROTECT,
            ),
        };
    },
    [PROTECT_RECORDING_FAILURE](
        state: RecordingsState = initialState,
    ): RecordingsState {
        return {
            ...state,
            nPVRActions: state.nPVRActions.filter(
                (action) => action !== NPVRAction.PROTECT,
            ),
        };
    },

    // UNPROTECT RECORDING
    [UNPROTECT_RECORDING](
        state: RecordingsState = initialState,
    ): RecordingsState {
        return {
            ...state,
            nPVRActions: [...state.nPVRActions, NPVRAction.UNPROTECT],
        };
    },
    [UNPROTECT_RECORDING_SUCCESS](
        state: RecordingsState = initialState,
    ): RecordingsState {
        return {
            ...state,
            nPVRActions: state.nPVRActions.filter(
                (action) => action !== NPVRAction.UNPROTECT,
            ),
        };
    },
    [UNPROTECT_RECORDING_FAILURE](
        state: RecordingsState = initialState,
    ): RecordingsState {
        return {
            ...state,
            nPVRActions: state.nPVRActions.filter(
                (action) => action !== NPVRAction.UNPROTECT,
            ),
        };
    },

    // DELETE RECORDING
    [DELETE_RECORDING](state: RecordingsState = initialState): RecordingsState {
        return {
            ...state,
            deleteRequest: {
                ...state.deleteRequest,
                status: RequestStatus.PENDING,
                errors: null,
            },
            nPVRActions: [...state.nPVRActions, NPVRAction.DELETE],
        };
    },
    [DELETE_RECORDING_SUCCESS](
        state: RecordingsState = initialState,
    ): RecordingsState {
        return {
            ...state,
            deleteRequest: {
                ...state.deleteRequest,
                status: RequestStatus.SUCCESS,
                errors: null,
            },
            nPVRActions: state.nPVRActions.filter(
                (action) => action !== NPVRAction.DELETE,
            ),
        };
    },
    [DELETE_RECORDING_FAILURE](
        state: RecordingsState = initialState,
        { payload }: ReturnType<typeof deleteRecordingFailure>,
    ): RecordingsState {
        return {
            ...state,
            deleteRequest: {
                ...state.deleteRequest,
                status: RequestStatus.FAILURE,
                errors: payload,
            },
            nPVRActions: state.nPVRActions.filter(
                (action) => action !== NPVRAction.DELETE,
            ),
        };
    },
    [CANCEL_RECORDING](state: RecordingsState = initialState): RecordingsState {
        return {
            ...state,
            nPVRActions: [...state.nPVRActions, NPVRAction.CANCEL],
        };
    },
    [CANCEL_RECORDING_SUCCESS](
        state: RecordingsState = initialState,
    ): RecordingsState {
        return {
            ...state,
            nPVRActions: state.nPVRActions.filter(
                (action) => action !== NPVRAction.CANCEL,
            ),
        };
    },
    [CANCEL_RECORDING_FAILURE](
        state: RecordingsState = initialState,
    ): RecordingsState {
        return {
            ...state,
            nPVRActions: state.nPVRActions.filter(
                (action) => action !== NPVRAction.CANCEL,
            ),
        };
    },

    // DELETE SERIES RECORDING
    [DELETE_SERIES_RECORDING](
        state: RecordingsState = initialState,
    ): RecordingsState {
        return {
            ...state,
            deleteSeriesRequest: {
                ...state.deleteSeriesRequest,
                status: RequestStatus.PENDING,
                errors: null,
            },
            nPVRActions: [...state.nPVRActions, NPVRAction.DELETE_SERIES],
        };
    },
    [DELETE_SERIES_RECORDING_SUCCESS](
        state: RecordingsState = initialState,
    ): RecordingsState {
        return {
            ...state,
            deleteSeriesRequest: {
                ...state.deleteSeriesRequest,
                status: RequestStatus.SUCCESS,
                errors: null,
            },
            nPVRActions: state.nPVRActions.filter(
                (action) => action !== NPVRAction.DELETE_SERIES,
            ),
        };
    },
    [DELETE_SERIES_RECORDING_FAILURE](
        state: RecordingsState = initialState,
        { payload }: ReturnType<typeof deleteSeriesRecordingFailure>,
    ): RecordingsState {
        return {
            ...state,
            deleteSeriesRequest: {
                ...state.deleteSeriesRequest,
                status: RequestStatus.FAILURE,
                errors: payload,
            },
            nPVRActions: state.nPVRActions.filter(
                (action) => action !== NPVRAction.DELETE_SERIES,
            ),
        };
    },

    [CANCEL_SERIES_RECORDING](
        state: RecordingsState = initialState,
    ): RecordingsState {
        return {
            ...state,
            nPVRActions: [...state.nPVRActions, NPVRAction.CANCEL_SERIES],
        };
    },
    [CANCEL_SERIES_RECORDING_SUCCESS](
        state: RecordingsState = initialState,
    ): RecordingsState {
        return {
            ...state,
            nPVRActions: state.nPVRActions.filter(
                (action) => action !== NPVRAction.CANCEL_SERIES,
            ),
        };
    },
    [CANCEL_SERIES_RECORDING_FAILURE](
        state: RecordingsState = initialState,
    ): RecordingsState {
        return {
            ...state,
            nPVRActions: state.nPVRActions.filter(
                (action) => action !== NPVRAction.CANCEL_SERIES,
            ),
        };
    },

    [GET_RECORDINGS_CACHE_SUCCESS](
        state: RecordingsState,
        {
            payload: { timestamp, recordings, series },
        }: ReturnType<typeof getRecordingsCacheSuceess>,
    ): RecordingsState {
        return {
            ...state,
            cache: {
                ...state.cache,
                timestamp,
                recordings,
                series,
            },
        };
    },

    [SET_DELETE_ACTION_PIN_VALIDATION_TIME](
        state: RecordingsState,
        {
            payload: { profileId, timestamp },
        }: ReturnType<typeof setDeleteActionPinValidationTime>,
    ): RecordingsState {
        if (timestamp != null) {
            return {
                ...state,
                deleteActionPinValidationTime: {
                    ...state.deleteActionPinValidationTime,
                    [profileId]: timestamp,
                },
            };
        }

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { [profileId]: _, ...rest } = state.deleteActionPinValidationTime;

        return {
            ...state,
            deleteActionPinValidationTime: rest,
        };
    },
};

export default { initialState, handlers };
